// EntryHomeTemplateコンポーネントをインポート
// エントリーホームページ用のテンプレートとして使用
import EntryHomeTemplate from "../templates/EntryHomeTemplate";

/** 
 * EntryHomePageコンポーネント
 * エントリー向けの「ホームページ」を表示するためのコンポーネント
 * EntryHomeTemplateを利用して、ホームページを構築
 */
const EntryHomePage = () => {

    // エントリーホームページテンプレートをレンダリング
    // 特にプロパティを渡さず、EntryHomeTemplateをそのまま利用
    return (
        <EntryHomeTemplate />
    );
}

// EntryHomePageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default EntryHomePage;
